import {Base} from "@/api/Base"

export class GeneralSalary extends Base {
    path = "report/generalSalary"
}